import React, { useState } from 'react';
import useAliceGPT from '../../../../Hooks/AliceGPT/useAliceGPT';
import * as AliceGPTEvents from '../../../../Context/AliceGPT/AliceGPTContextEvents';
import { Checkbox } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import startsWithNumber from '../../../Helpers/Validators/startsWithNumber';
import { useTranslation } from 'react-i18next';
import { LanguagesMap } from '../../../OrganizationSettings/LanguagesMap';

function AliceProjectDetailsForm({ checkDuplicateProjectName, showAIFields, showLanguageDropdown }) {

    const { t } = useTranslation("create_project/alice_project_details_form", { useSuspense: false });

    const [{ form, showAdvancedConfigurations }, dispatch] = useAliceGPT();

    const isProjectNameUsed = checkDuplicateProjectName();
    const hasSpecialCharacters = /[^a-zA-Z0-9 ]/g.test(form.projectName);

    function handleFormChange(e) {
        const { name, value, maxLength } = e.target;
        let newValue = value;
        if (maxLength && maxLength > 0 && value.length > maxLength) {
            newValue = value.substring(0, maxLength);
        };
        const newFormDetails = { ...form, [name]: newValue };
        dispatch({ type: AliceGPTEvents.FORM_UPDATED, payload: newFormDetails });
    }

    function toggleAdvancedConfiguration() {
        if (showAdvancedConfigurations) {
            dispatch({ type: AliceGPTEvents.HIDE_ADVANCED_CONFIGURATIONS });
        } else {
            dispatch({ type: AliceGPTEvents.SHOW_ADVANCED_CONFIGURATIONS });
        }
    }

    return (
        <form
            className='container-fluid d-flex justify-content-center'
            onSubmit={(e) => e.preventDefault()}
        >
            <div className='row w-50'>
                <div className='col-12'>
                    <div className='form-group'>
                        <label className='form-label' htmlFor='app-name-field' required>
                            {t("form_labels.app_name")}
                            {
                                isProjectNameUsed && (
                                    <span className='text-danger'>
                                        &nbsp;{t("errors.app_name_taken")}
                                    </span>
                                )
                            }
                            {
                                hasSpecialCharacters && (
                                    <span className='text-danger'>
                                        &nbsp;{t("errors.app_name_has_sp_chars")}
                                    </span>
                                )
                            }
                            {
                                form.projectName &&
                                startsWithNumber(form.projectName.trim()) && (
                                    <span className='text-danger'>
                                        &nbsp;{t("errors.app_name_can_not_start_with_number")}
                                    </span>
                                )
                            }
                        </label>
                        <input
                            id="app-name-field"
                            type='text'
                            className='form-control'
                            placeholder={t("form_labels.app_name_placeholder")}
                            name='projectName'
                            onChange={handleFormChange}
                            value={form.projectName}
                            maxLength={64}
                            autoFocus
                        />
                    </div>
                    {
                        showLanguageDropdown &&
                        <div className="form-group">
                            {/* TODO: Support static translation */}
                            <label className="form-label">
                                {t("form_labels.select_language")}
                            </label>
                            <DropDownList
                                name="language"
                                data={LanguagesMap}
                                value={form.language}
                                textField='name'
                                onChange={handleFormChange}
                            />
                        </div>
                    }
                    {
                        showAIFields &&
                        <div className='form-group'>
                            <label className='form-label'>
                                { t("form_labels.description") }
                            </label>
                            <textarea
                                className='form-control'
                                placeholder={t("form_labels.description_placeholder")}
                                name='description'
                                onChange={handleFormChange}
                                value={form.description}
                                rows={7}
                            />
                        </div>
                    }
                </div>
                {/* <div className='col-12'>
                    <button
                        className='btn btn-link px-0'
                        type='button'
                        onClick={toggleAdvancedConfiguration}
                    >
                        Show advanced configuration
                    </button>
                </div>
                {
                    showAdvancedConfigurations && (
                        <div className='col-12'>
                            <div className='form-group'>
                                <label className='form-label'>
                                    Model
                                </label>
                                <DropDownList
                                    name="model"
                                    data={["gpt-3.5-turbo", "gpt-4"]}
                                    value={form.model}
                                    onChange={handleFormChange}
                                />
                            </div>
                        </div>
                    )
                } */}
            </div>
        </form>
    )
}

export default AliceProjectDetailsForm;